require("../../scss/indexFiltered.scss");
import ScrollReveal from 'scrollreveal';
import imagesLoaded from 'imagesLoaded';
import Isotope from 'isotope-layout';

var indexFiltered = function(){

	var filters = [];
	var showFilters, filterSelect, initIsotope, iso, isoOpts, filterHashChange, getFilterTypeByFilterValue;

	constructor = function(){
		//setup filter array, all epty
		$(".filterGroup").each(function(index, value){
			filters[$(value).data("filter")] = "";
		});
		//preload images
		imagesLoaded(document.querySelector('#boxDisplay'), {background: true}, initIsotope)
	}

	initIsotope = function(){
		//init filters
		$(".filterGroup").find("a").click(function(){
			var nval = $(this).attr("href").substring(1);
			var thisGroup = $(this).closest("ul");
			var filterName = thisGroup.data("filter");

			filterSelect(filterName, nval);

			return false;
		});

		$("select.filtros").change(function(){
			var nval = $(this).val();
			var filterName = $(this).data("filter");
			filterSelect(filterName, nval);
		});

		//for database filtering logic select
		$("select.filtrosLink").change(function(){
			var nval = $(this).val();
			window.location.href = nval;
		});

		var elem = document.querySelector('#boxDisplay');
		isoOpts = {
		  // options
		  itemSelector: '.grid-item',
		  layoutMode: 'fitRows',
		  percentPosition: true,
		  transformsEnabled:false,
		  masonry:{
		  	gutter: 0,
		  	columnWidth: '.grid-sizer'
		  }
		};
		iso = new Isotope( elem, isoOpts);
		
		TweenMax.staggerFromTo("#boxDisplay .squareBox", 0.4, {autoAlpha:0}, {autoAlpha:1}, 0.1);
		TweenMax.set(".grid-item", {position:"absolute"});

		APP.addHashChangeCallback(filterHashChange);

		//start the thing
		filterHashChange();
	}

	filterSelect = function(filterName, nval){
		//if the same filter, toggle behaviour
		if(filters[filterName] == nval){
			filters[filterName] = "";
		}else{
			filters[filterName] = nval;
		} 
		var h = "";
		//set the hash based on current filter
		for (var filter in filters) {
			if(filters[filter] != "")h += "_"+filters[filter];
		}
		//set the hash and let the hash callback do the magic
		window.location.href = "#"+h.substring(1);
	}

	//pasrse filters from hash, dash separated
	filterHashChange = function(){
		var hash = APP.getHash();
		if(!hash){
			showFilters();
			return;
		}
		var f = hash.split("_");
		//empty all filters
		for (var filter in filters) {
			filters[filter] = "";
		}
		//get filter name based on value, and apply value
		for (var i = f.length - 1; i >= 0; i--) {
			filters[getFilterTypeByFilterValue(f[i])] = f[i];
		}
		showFilters();
	}

	getFilterTypeByFilterValue = function(fValue){
		return $("a[href='#"+fValue+"']").closest("ul.filterGroup").data("filter");
	}

	showFilters = function(){
		var f = '';
		for (var filter in filters) {
			//show active guys
			var filterGroup = $("ul[data-filter='"+filter+"']");
			var filterSelect = $("select[data-filter='"+filter+"']");
			filterGroup.find("a").removeClass("active");
			//set the guy as active, otherwise, set the generic one
			if(filters[filter]){
				filterGroup.find("a[href='#"+filters[filter]+"']").addClass("active");
			}else{
				filterGroup.find("a[href='#']").addClass("active");
			}
			//set the value on the select
			filterSelect.val(filters[filter])

			//prepare array for isotope classes
			if(filters[filter] != '') f+= "."+filters[filter];
		}
		console.log(f);
		iso.arrange({ filter: f });
	}

	resizeWin = function(viewportSize){

	}

	$(document).ready(constructor);

	return {
		resize: resizeWin
	}
}

indexFiltered();